var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-container"},[_c('div',{staticClass:"error"},[_c('div',{staticClass:"error-inner"},[_c('h2',{staticClass:"title"},[_vm._v("404")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("对不起,我们找不到这个页面")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.indexUrl}},[_c('img',{attrs:{"src":require("../assets/images/logo-dark.svg"),"alt":""}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68fca674","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Error.vue
// module id = null
// module chunks = 